class ImageGalleryNav extends HTMLElement {
  constructor() {
    super();
    this.navButton = this.querySelector('.image-gallery__nav-button');
    this.scroller = this.querySelector('.image-gallery__scroller');
    this.items = Array.from(this.querySelectorAll('.image-gallery__item'));
    
    // Lightbox elements
    this.lightbox = this.querySelector('.image-gallery__lightbox');
    this.lightboxOverlay = this.querySelector('.image-gallery__lightbox-overlay');
    this.lightboxClose = this.querySelector('.image-gallery__lightbox-close');
    this.lightboxPrev = this.querySelector('.image-gallery__lightbox-nav--prev');
    this.lightboxNext = this.querySelector('.image-gallery__lightbox-nav--next');
    this.lightboxMediaContainer = this.querySelector('.image-gallery__lightbox-media');
    
    this.currentLightboxIndex = 0;

    if (!this.scroller) return;

    if (this.navButton) this.navButton.addEventListener('click', this.onNavClick.bind(this));
    
    // Lightbox listeners
    if (this.lightbox) {
      // Move lightbox to body to avoid z-index/transform stacking issues from parents
      document.body.appendChild(this.lightbox);

      this.items.forEach((item, index) => {
        item.addEventListener('click', () => this.openLightbox(index));
        item.style.cursor = 'zoom-in';
      });
      
      this.lightboxClose.addEventListener('click', this.closeLightbox.bind(this));
      this.lightboxOverlay.addEventListener('click', this.closeLightbox.bind(this));
      this.lightboxPrev.addEventListener('click', () => this.navigateLightbox(-1));
      this.lightboxNext.addEventListener('click', () => this.navigateLightbox(1));
      
      // Keyboard nav
      document.addEventListener('keydown', (e) => {
        if (this.lightbox.hasAttribute('hidden')) return;
        if (e.key === 'Escape') this.closeLightbox();
        if (e.key === 'ArrowLeft') this.navigateLightbox(-1);
        if (e.key === 'ArrowRight') this.navigateLightbox(1);
      });
    }
  }

  onNavClick() {
    // Scroll by the width of one item + gap
    const item = this.items[0];
    if (!item) return;
    
    const scrollAmount = item.clientWidth + 16; 
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    
    if (this.scroller.scrollLeft >= maxScroll - 10) {
      this.scroller.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      this.scroller.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  }
  
  openLightbox(index) {
    this.currentLightboxIndex = index;
    this.updateLightboxMedia();
    this.lightbox.removeAttribute('hidden');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }
  
  closeLightbox() {
    this.lightbox.setAttribute('hidden', '');
    document.body.style.overflow = '';
    this.lightboxMediaContainer.innerHTML = ''; // Stop video playback if any
  }
  
  navigateLightbox(direction) {
    this.currentLightboxIndex += direction;
    
    if (this.currentLightboxIndex < 0) {
      this.currentLightboxIndex = this.items.length - 1;
    } else if (this.currentLightboxIndex >= this.items.length) {
      this.currentLightboxIndex = 0;
    }
    
    this.updateLightboxMedia();
  }
  
  updateLightboxMedia() {
    const activeItem = this.items[this.currentLightboxIndex];
    if (!activeItem) return;
    
    // Shopify video_tag might wrap video in other elements or just be a video
    const img = activeItem.querySelector('img');
    const video = activeItem.querySelector('video');
    
    this.lightboxMediaContainer.innerHTML = '';
    
    if (video) {
      const clonedVideo = video.cloneNode(true);
      clonedVideo.controls = true; // allow controls in lightbox
      clonedVideo.autoplay = true; // start playing when opened
      clonedVideo.muted = false; // allow sound inside lightbox
      clonedVideo.style.maxWidth = '100%';
      clonedVideo.style.maxHeight = '90vh';
      this.lightboxMediaContainer.appendChild(clonedVideo);
      
      // Attempt to play immediately
      const playPromise = clonedVideo.play();
      if (playPromise !== undefined) {
          playPromise.catch(_error => {
              // Auto-play was prevented. Show paused UI.
          });
      }
    } else if (img) {
      const clonedImg = img.cloneNode(true);
      // Try to load a higher res version if width parameter is present
      if (clonedImg.src.includes('width=300')) {
         clonedImg.src = clonedImg.src.replace('width=300', 'width=1200');
      }
      this.lightboxMediaContainer.appendChild(clonedImg);
    }
  }
}

customElements.define('image-gallery-nav', ImageGalleryNav);
